import { render, staticRenderFns } from "./SectionSwitch.vue?vue&type=template&id=a09e4372&lang=pug&"
import script from "./SectionSwitch.vue?vue&type=script&lang=js&"
export * from "./SectionSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports